import React from "react";
import Dialog from "@material-ui/core/Dialog";
import cx from "classnames";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./styles.scss";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { instanceOf, shape } from "prop-types";

const style = theme => ({
    progress: {
        margin: theme.spacing(2)
    },
    root: {
        backgroundColor: "rgba(0, 0, 0, 0.1)"
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    }
});

@connect(state => ({
    loading: state.notification.loading
}), null
)

class AlertDialog extends React.Component {
    static propTypes = {
        loading: shape(Object),
        classes: instanceOf(Object)
    };
    state = {
        open: false
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { loading, classes } = this.props;
        return (
            <div>
                <Dialog
                    open={loading.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                            this.handleClose(reason);
                        }
                    }}
                    BackdropProps={{
                        classes: {
                            root: classes.root
                        }
                    }
                    }
                    PaperProps={{
                        classes: {
                            root: classes.paper
                        }
                    }}
                >
                    <div className={cx(styles["loading_div"])} id="loading_screen">
                        <div className={cx(styles["inside"])}>
                            <CircularProgress className={classes.progress} size={50} />
                            {loading.message}
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

AlertDialog.defaultProps = {
    loading: {
        message: "Loading...",
        open: false
    }
};

export default withStyles(style)(AlertDialog);
